import React from "react";
import { shallowEqual, useSelector } from "react-redux";
import { Redirect, Route } from "react-router-dom";
import { Content } from "./Content";

export function ContentRoute({ children, component, render, ...props }) {
  const user = useSelector(({ auth }) => auth.user, shallowEqual);
  const hasPermission = (permission) => {
    if (!user.permissions.some((p) => p.urlFrontEnd === permission)) {
      var newString = permission
        .substr(0, permission.lastIndexOf("/"))
        .concat("/:id");
      if (user.permissions.some((p) => p.urlFrontEnd === newString)) {
        return true;
      } else {
        return false;
      }
    }

    return true;
  };
  return (
    <Route {...props}>
      {(routeProps) => {
        if (typeof children === "function") {
          return <Content>{children(routeProps)}</Content>;
        }

        if (!routeProps.match) {
          return null;
        }

        if (children) {
          return <Content>{children}</Content>;
        }

        if (component) {
          var pathname = routeProps.location.pathname;
          if (pathname === "/auth/login" || /activatePassword/.test(pathname)) {
            return (
              <Content>{React.createElement(component, routeProps)}</Content>
            );
          }
          if (hasPermission(pathname)) {
            return (
              <Content>{React.createElement(component, routeProps)}</Content>
            );
          } else {
            if (user) {
              return (
                /* Redirect login page */
                <Redirect exact={true} to="/dashboard" />
              );
            } else {
              return (
                /* Redirect login page */
                <Redirect exact={true} to="/logout" />
              );
            }
          }
        }

        if (render) {
          return <Content>{render(routeProps)}</Content>;
        }

        return null;
      }}
    </Route>
  );
}
